exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".admin-list-container {\n    min-height: 32px;\n    height: 32px;\n    width: 200px;\n}\n\n.admin-menu-container {\n    border-radius: 4px;\n    box-shadow: rgba(8, 9, 18, 0.16) 0px 4px 16px;\n}\n\n.admin-list-item {\n    color: #33343D;\n    font-family: \"Inter\";\n    font-size: 12px;\n    font-weight: 400px;\n    font-style: normal;\n    padding: 8px;\n}\n\n.admin-list-active {\n    .admin-list-item { color: #3246F0 }\n}\n", ""]);

// exports
